import {
  fetchRealmOutfitsRegions,
  resetRealmOutfitsRegions
} from 'modules/realm-outfits/reducers/realm-outfits-regions';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { State } from 'types';

export function useCountries() {
  const dispatch = useDispatch();

  const regions = useSelector(
    (state: State) => state.realmOutfitsRegions.regions ?? []
  );

  useEffect(() => {
    dispatch(fetchRealmOutfitsRegions());

    return () => {
      dispatch(resetRealmOutfitsRegions());
    };
  }, []);

  return regions.slice().sort();
}
